import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

const StyledSection = styled('section')(({ theme, bg, useBrandFont = true }) => ({
  background: bg
    ? theme.palette.background[bg]
    : theme.palette.background.gradient,
  color: theme.palette.text.primary,
  overflowWrap: 'anywhere',
  padding: theme.spacing(10, 3),
  position: 'relative',
  width: '100%',
  minHeight: '80vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  h1: {
    fontSize: '1.8rem',
    margin: theme.spacing(1, 0),
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: useBrandFont ? 'Usuzi' : 'inherit',
    scrollMarginTop: '10vw',
  },
  a: {
    color: theme.palette.text.primary,
  },
  '.content': {
    // maxWidth: '80vw',
    '&.center': {
      textAlign: 'center',
    },
  },
  img: {
    maxWidth: '100%',
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(10),
    '.content': {
      // maxWidth: '40vw',
      '&.center': {
        textAlign: 'center',
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    minHeight: '88vh',
    h1: {
      fontSize: '2.5vw',
      margin: theme.spacing(1, 0),
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2vw',
    },
    h3: {
      fontSize: '1.6vw',
    },
    h4: {
      fontSize: '1.5vw',
    },
    h5: {
      fontSize: '1.4vw',
    },
    p: {
      fontSize: '1.4vw',
    },
    ul: {
      fontSize: '1.4vw',
    },
    '.content': {
      maxWidth: '56vw',
      '&.center': {
        textAlign: 'center',
      },
      '&.left': {
        maxWidth: '36vw',
      },
    },
  },
  // [theme.breakpoints.up('xl')]: {
  //   '.content': {
  //     maxWidth: '50vw',
  //   },
  // },
}));

const PageSection = ({ children = null, ...props }) => {
  return (
    <StyledSection {...props}>
      {children}
    </StyledSection>
  );
};

PageSection.propTypes = {
  children: PropTypes.node,
};

export default PageSection;
